<template>
  <el-card class="notice-detail">
    <p class="title">{{ $t('customer::customers-notice::activity_info') }}</p>
    <el-form class="form">
      <el-form-item :label="$t('customer::customers-notice::avtivity_name')">
        {{ emailModel.name }}
      </el-form-item>
      <el-form-item :label="$t('customer::customers-notice::email_obj')">
        {{ checkReceiver(emailModel) }}
      </el-form-item>
      <el-form-item :label="$t('customer::customers-notice::send_time')">
        {{ emailModel.sentDate }}
      </el-form-item>
    </el-form>
    <p class="title">{{ $t('customer::customers-notice::emial_content') }}</p>
    <RichEditor v-model="emailModel.content" :placeholder="$t('customer::customers-notice::content')" />
  </el-card>
</template>

<script>
import RichEditor from '@/components/rich-editor'
import { STEP_STAUTS } from '../config'
import { getEmailDetail } from '@/server/customers'
export default {
  components: {
    RichEditor
  },
  data() {
    return {
      emailModel: {},
      stepStauts: STEP_STAUTS
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.getEmailDetail(this.$route.params.id)
    }
  },
  methods: {
    checkReceiver(row) {
      if (row.filter === 0) {
        return $t('customer::customers-notice::all_user')
      } else if (row.filter === 3) {
        return $t('customer::customers-notice::count') + this.stepStauts[row.filterValue]
      } else {
        return row.filterName
      }
    },
    async getEmailDetail(id) {
      const { data } = await getEmailDetail({ id: id })
      if (data.code === this.$code) {
        this.emailModel = { ...this.emailModel, ...data.data }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-detail {
  .title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .form {
    margin-left: 10px;
    margin-bottom: 20px;
    ::v-deep.el-form-item {
      margin-bottom: 0;
    }
    ::v-deep.el-form-item__label {
      color: inherit;
    }
  }
}
</style>
